import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'pemutihanAbsen'
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE
const outputType = 'json'

export const employeeList = 'Master/pemutihanAbsen/listEmployee/'

export const pemutihanAbsenCreate = 'Master/pemutihanAbsen/create/'
export const pemutihanAbsenList = 'Master/pemutihanAbsen/list/'
export const pemutihanAbsenDetail = 'Master/pemutihanAbsen/detail/'
export const pemutihanAbsenUpdate = 'Master/pemutihanAbsen/update/'
export const pemutihanAbsenInactive = 'Master/pemutihanAbsen/inactive/'
export const pemutihanAbsenActive = 'Master/pemutihanAbsen/active/'
export const pemutihanAbsenProcess = 'Master/pemutihanAbsen/process/'

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken=true) => {
    if(needToken) {
        const thisTime = (Math.floor(Date.now()/1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if(expire < thisTime) {
           await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
           .then(result => {
                localStorage.setItem(initial + 'accessToken', result.response.access_token)
                return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
            })
            .catch(result => {
                return Promise.reject('Tidak dapat mengambil accessToken');
            })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)        
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}